import './App.css';
import React from "react";
import code from "./images/code.png"
import logo from "./images/logo.png"
import stats from "./images/icon_stats.png"
import {store} from "./store";
import {getCompany, getLocation, getScans, getRank, getDaily, getMonthlyBaseline} from "./apiCaller";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import Location from "./Location";
import CircleIcon from '@mui/icons-material/Circle';

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}


function TestError() {
    const a = null;
    return a.hello();
}

class MultiLocationApp extends React.Component{

    constructor(props) {
        super(props);

        this.state = {
            deviceToken: "",
            company: {baseline: Number(getCookie("baseline"))},
            locations: [{
                ID: 0,
                children: []
            },
            {
                ID: 1,
                children: []
            }],
            location: {
                ID: 0,
                children: []
            },
            currentLocation: 0,
            count: 0,
            rank: 0,
            showStats: false,
            stats: [{name: 'Loading',
                scans: 0}],
            statsBarOffset: 0,
            host: store.getState().host,
            logoToken: "noToken",
            monthlyBaselineData: [{name: 'Loading',
                scans: 0, baseline: 0}],
            isOnline: navigator.onLine,

        }

        this.touchStartX = 0;
        this.touchEndX = 0;

    }



    componentDidMount = async () => {

        console.error("Mounting Multi Location")

        this.startupTouchEvents()

        //let viewportHeight = window.innerHeight;
        //document.getElementById("height").innerText = viewportHeight

        if (document.getElementById("devtoken") == undefined){
            fetch("/api/config/getToken")
                .then((response) => response.text())
                .then((token) => {
                    var element = document.createElement("input")
                    element.type = "hidden"
                    element.value = token
                    element.id = "devtoken"
                    document.body.appendChild(element)

                    store.dispatch({"type": "devToken", "payload": token})
                })


        }


        window.addEventListener('error', (event) => {
            console.warn("error")
            //this.props.rollbar.error('Console Error', event);
        }, true); // The `true` argument enables capture phase for catching errors early
        window.addEventListener("unhandledrejection", function (event) {
            console.warn("error")
            //this.props.rollbar.error('Console Error', event);
        });
        const img = document.querySelector('img');
        img.addEventListener('error', (event) => {
            console.warn("error")
            //this.props.rollbar.error('Console Error', event);
        });

        console.log(console.log('navigator.onLine:', navigator.onLine))
        window.addEventListener('online', this.updateOnlineStatus);
        window.addEventListener('offline', this.updateOnlineStatus);

        store.subscribe(() => {


            var newScans = store.getState().scans

            console.log(newScans)

            if(newScans !== this.state.count){

                getLocation((location) =>{
                    var locations = []
                    locations.push(location)
                    for (let i = 0; i < location.children.length; i++) {
                        console.log(location.children[i]); // Accesses the element at index i
                        locations.push(location.children[i])
                    }
                    console.error(locations)
                    this.setState({location: location, locations: locations.sort((a, b) => a.ID - b.ID)})

                })

                document.cookie = `scans=${newScans}; expires=Thu, 18 Dec 2100 12:00:00 UTC`;
                this.setState({count: newScans})
                getDaily((response) =>{
                    console.log(response)
                    var data = []
                    for (let i = 0; i < response.length; i++) {
                        var date = new Date(response[i].scandate)
                        var dateString = (date.getMonth() + 1) + "/" + (date.getDate() + 1)
                        data.push({
                            name: dateString,
                            scans: parseInt(response[i].uniquevisitors),
                        })
                    }
                    this.setState({stats: data})
                })
                
                getMonthlyBaseline((response) =>{
                    console.log(response)
                    var data = []
                    for (let i = 0; i < response.length; i++) {
                        var date = new Date(response[i].scandate)
                        var dateString = (date.getMonth() + 1) + "/" + (date.getDate() + 1)
                        data.push({
                            name: dateString,
                            scans: parseInt(response[i].uniquevisitors),
                            baseline: parseInt(response[i].baseline),
                        })
                    }
                    this.setState({monthlyBaselineData: data})
                })
            }

            var host = store.getState().host
            if(host !== this.state.host){
                this.setState({host: host})
            }

            var logoToken = store.getState().logoToken
            if(this.state.logoToken !== logoToken){
                this.setState({logoToken: logoToken})
            }

            var rank = store.getState().rank
            if(this.state.rank !== rank){
                document.cookie = `rank=${rank}; expires=Thu, 18 Dec 2100 12:00:00 UTC`;
                this.setState({rank: rank})
            }

            var location = store.getState().location
            if(this.state.location !== location){
                console.log("update location")
                document.cookie = `locationid=${location.ID}; expires=Thu, 18 Dec 2100 12:00:00 UTC`;
                document.cookie = `locationname=${location.name}; expires=Thu, 18 Dec 2100 12:00:00 UTC`;
                var locations = []
                locations.push(location)
                for (let i = 0; i < (location?.children || []).length; i++) {
                    console.log(location.children[i]); // Accesses the element at index i
                    locations.push(location.children[i])
                }
                console.error(locations)
                this.setState({location: location, locations: locations.sort((a, b) => a.ID - b.ID)})
            }
        })
        this.setState({deviceToken: store.getState().deviceToken, host: store.getState().host})
        console.log("getting scans")
        getScans((response) =>{
            console.log(response)
            store.dispatch({"type": "scans/update", "payload": response.visitors})
        })
        getCompany((response) =>{
            document.cookie = `baseline=${response.baseline}; expires=Thu, 18 Dec 2100 12:00:00 UTC`;
            this.setState({company: response})
        })
        getLocation((location) =>{
            var locations = []
            locations.push(location)
            for (let i = 0; i < location.children.length; i++) {
                console.log(location.children[i]); // Accesses the element at index i
                locations.push(location.children[i])
            }
            console.error(locations)
            this.setState({location: location, locations: locations.sort((a, b) => a.ID - b.ID)})

        })
        getRank((response) =>{
            console.log(response)
            this.setState({rank: response})
            store.dispatch({"type": "leaderboard/updateRank", "payload": response})
        })

        getDaily((response) =>{
            console.log(response)
            var data = []
            for (let i = 0; i < response.length; i++) {
                var date = new Date(response[i].scandate)
                var dateString = (date.getMonth() + 1) + "/" + (date.getDate() + 1)
                data.push({
                    name: dateString,
                    scans: parseInt(response[i].uniquevisitors),
                })
            }
            this.setState({stats: data})
        })

        getMonthlyBaseline((response) =>{
            console.log(response)
            var data = []
            for (let i = 0; i < response.length; i++) {
                var date = new Date(response[i].scandate)
                var dateString = (date.getMonth() + 1) + "/" + (date.getDate() + 1)
                data.push({
                    name: dateString,
                    scans: parseInt(response[i].uniquevisitors),
                    baseline: parseInt(response[i].baseline),
                })
            }
            this.setState({monthlyBaselineData: data})
        })
        await new Promise(r => setTimeout(r, 2000));

        if(this.state.location.ID === 0){

            getScans((response) =>{
                console.log(response)
                store.dispatch({"type": "scans/update", "payload": response.visitors})
            })
            getCompany((response) =>{
                this.setState({company: response})
            })
            getLocation((location) =>{
                var locations = []
                locations.push(location)
                for (let i = 0; i < location.children.length; i++) {
                    console.log(location.children[i]); // Accesses the element at index i
                    locations.push(location.children[i])
                }
                console.error(locations)
                this.setState({location: location, locations: locations.sort((a, b) => a.ID - b.ID)})

            })
            getRank((response) =>{
                console.log(response)
                this.setState({rank: response})
                store.dispatch({"type": "leaderboard/updateRank", "payload": response})
            })

            getDaily((response) =>{
                console.log(response)
                var data = []
                for (let i = 0; i < response.length; i++) {
                    var date = new Date(response[i].scandate)
                    var dateString = (date.getMonth() + 1) + "/" + (date.getDate() + 1)
                    data.push({
                        name: dateString,
                        scans: parseInt(response[i].uniquevisitors),
                    })
                }
                this.setState({stats: data})
            })

            getMonthlyBaseline((response) =>{
                console.log(response)
                var data = []
                for (let i = 0; i < response.length; i++) {
                    var date = new Date(response[i].scandate)
                    var dateString = (date.getMonth() + 1) + "/" + (date.getDate() + 1)
                    data.push({
                        name: dateString,
                        scans: parseInt(response[i].uniquevisitors),
                        baseline: parseInt(response[i].baseline),
                    })
                }
                this.setState({monthlyBaselineData: data})
            })
        }
    }

    componentWillUnmount() {
        window.removeEventListener('online', this.updateOnlineStatus);
        window.removeEventListener('offline', this.updateOnlineStatus);
        document.removeEventListener('touchstart', this.onTouchStart);
        document.removeEventListener('touchend', this.onTouchEnd);

        const touchTarget = document.getElementById('statsTouchTarget');
        if (touchTarget) {
            touchTarget.removeEventListener('touchstart', this.handleTouchStart);
        }
        this._touchBound = false;
    }

    updateOnlineStatus = () => {
        console.log(`is ${navigator.onLine ? "online" : "offline"}`);
        this.setState({ isOnline: navigator.onLine });
    }

    changeStatsVis = async () => {
        var statsBar = document.getElementById("statsBar")
        if(this.state.statsBarOffset === 0){
            await this.setState({statsBarOffset: statsBar.offsetTop})
        }
        const endingPos = 150

        if (!this.state.showStats) {
            await this.setState({showStats: !this.state.showStats})
            statsBar.style.top = this.state.statsBarOffset + "px"
            for (let i = this.state.statsBarOffset; i > endingPos; i--) {
                i -= 30

                if(i <= endingPos){
                    statsBar.style.top = endingPos + "px"
                    break
                }
                statsBar.style.top = i + "px"

                await new Promise(r => setTimeout(r, 0));

            }
            statsBar.style.top = endingPos + "px"
        } else{

            for (let i = endingPos; i < this.state.statsBarOffset; i++) {
                i += 30
                statsBar.style.top = i + "px"
                await new Promise(r => setTimeout(r, 0));
            }
            statsBar.style.top = this.state.statsBarOffset + "px"
            await this.setState({showStats: !this.state.showStats})

        }

    }

    showWifiModule = () => {
        document.getElementById("root").style.display = "none"
        document.getElementById("wifiModule").style.display = "block"
    }

    onTouchStart = (e) => {
        this.touchStartX = e.changedTouches[0].clientX;
    };
    onTouchEnd = (e) => {
        this.touchEndX = e.changedTouches[0].clientX;
        this.handleGesture();
    };

    startupTouchEvents = () => {
        if (this._touchBound) return;        // ← don’t bind twice
        this._touchBound = true;

        document.addEventListener('touchstart', this.onTouchStart, { passive: true });
        document.addEventListener('touchend', this.onTouchEnd, { passive: true });

        const touchTarget = document.getElementById('statsTouchTarget');
        if (touchTarget) {
            touchTarget.addEventListener('touchstart', this.handleTouchStart, { passive: true });
        }
    };

    handleTouchStart = () => {
        this.changeStatsVis();
    };

    handleGesture = () => {
        const threshold = 50;
        const dx = this.touchEndX - this.touchStartX;

        if (dx < -threshold) {
            this.setState(prev => ({
                currentLocation: (prev.currentLocation + 1) % prev.locations.length
            }));
            document.getElementById("height").innerText = "Swipe Next";
        } else if (dx > threshold) {
            this.setState(prev => ({
                currentLocation: (prev.currentLocation - 1 + prev.locations.length) % prev.locations.length
            }));
            document.getElementById("height").innerText = "Swipe Prev";
        }
    };





    render() {
        console.log(this.state)
    return (
        <>


            <div className={"html"}>
                <div className={"body"}>

                    <div>
                        <div>
                            {
                                this.state.locations.map((location, index) => <Location key={location.ID} idx={index} show={index === this.state.currentLocation} host={this.state.host} deviceToken={this.state.deviceToken} topLocation={this.state.location} location={location} rank={this.state.rank} isOnline={this.state.isOnline} company={this.state.company}/>)
                            }

                        </div>
                    </div>

                    <div>

                    </div>

                    <div style={{position: "absolute", width: "100%", bottom: "0px"}} id={"statsBar"}>
                        <div style={{textAlign: "center", display: this.state.showStats? "none" : ""}}>
                            {
                                this.state.locations.map((location, index) => <CircleIcon key={index} style={{height: "10px", color: index === this.state.currentLocation ? "" : "lightgrey"}}/>)
                            }

                        </div>
                        <div className={"stats"} id={"statsTouchTarget"}
                             style={{paddingBottom: "0px", marginLeft: "5%", marginRight: "5%", cursor: "pointer"}}>
                            <h3 style={{paddingBottom: "0px", marginBottom: "9px"}}>
                                {/*<a href="#" data-bs-toggle="collapse" data-bs-target="#statsContent" id="statsTrigger">*/}
                                <a>
                                    <img src={stats} alt={""}/> Stats
                                </a>
                            </h3>
                        </div>

                        <div id="statsContent" className="test" style={{
                            marginLeft: "5%",
                            marginRight: "5%",
                            display: this.state.showStats ? "block" : "none",
                            height: "100%"
                        }}>
                            <div className="container" style={{
                                height: "100%",
                                paddingLeft: "0px",
                                overflowY: "scroll",
                                paddingBottom: "100px"
                            }}>
                                <h4>Daily Scans</h4>
                                <LineChart
                                    width={500}
                                    height={300}
                                    data={this.state.stats}
                                    margin={{
                                        top: 5,
                                        right: 30,
                                        left: 0,
                                        bottom: 5,
                                    }}
                                >
                                    <CartesianGrid strokeDasharray="3 3"/>
                                    <XAxis dataKey="name"/>
                                    <YAxis/>
                                    <Tooltip/>
                                    <Legend/>
                                    <Line type="monotone" dataKey="scans" stroke="#82ca9d"/>

                                </LineChart>
                                <p style={{textAlign: "center"}}>Total: {this.state.count}</p>
                                <br/>
                                <hr style={{marginRight: "-20px"}}/>
                                <h4>Monthly Baseline</h4>
                                <LineChart
                                    width={500}
                                    height={300}
                                    data={this.state.monthlyBaselineData}
                                    margin={{
                                        top: 5,
                                        right: 30,
                                        left: 0,
                                        bottom: 5,
                                    }}
                                >
                                    <CartesianGrid strokeDasharray="3 3"/>
                                    <XAxis dataKey="name"/>
                                    <YAxis/>
                                    <Tooltip/>
                                    <Legend/>
                                    <Line type="monotone" dataKey="scans" stroke="#82ca9d"/>
                                    <Line type="monotone" dataKey="baseline" stroke="#ca8287"/>
                                </LineChart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
        ;
    }
}

export default MultiLocationApp;
